import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSwitching = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M17.831 2.74a.5.5 0 0 0-.832.373V5h-3.5a1 1 0 1 0 0 2H17v1.886a.5.5 0 0 0 .832.374l3.248-2.886a.5.5 0 0 0 0-.748L17.83 2.74Zm-11.664 12a.5.5 0 0 1 .832.373V17h3.5a1 1 0 0 1 0 2H7v1.886a.5.5 0 0 1-.832.374L2.92 18.374a.5.5 0 0 1 0-.748l3.247-2.886Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.167 5.74A.5.5 0 0 1 7 6.113V8h3.5a1 1 0 0 1 0 2H7v1.886a.5.5 0 0 1-.832.374L2.92 9.374a.5.5 0 0 1 0-.748L6.167 5.74Zm11.664 6a.5.5 0 0 0-.832.373V14h-3.5a1 1 0 1 0 0 2H17v1.887a.5.5 0 0 0 .832.373l3.248-2.886a.5.5 0 0 0 0-.748l-3.25-2.886Z",
  fill: "var(--mds-nav-icon-medium)"
})), "IcSwitching");

export { IcSwitching };
//# sourceMappingURL=ic-switching.js.map
